import React from "react";
import style from "./debridement.module.scss";
import { Button, Form, SelectBox, RadioButton, MultiSelect, TextField } from "../../../primary";
import { TreatmentDropDownItem } from "../../../secondary";
import { CANCEL_BTN, SAVE_BTN, MULTISELECT_SUB_LABLE } from "../../../../constants";
import {
  surgicalDebridementPerformed,
  debridementPerformedBy,
  nonExcisionalApproach,
  typeProcedure,
  DepthofDebridement,
  debridedNecroticSkin,
  signedLockedAccess,
} from "../../../../utils";
import { ReadOnlyBanner } from "../../../secondary/ReadOnlyBanner/ReadOnlyBanner";

export const DebridementEditMode = ({
  assessmentDetails,
  setFormChangesConfirm,
  handleSubmit,
  doSubmit,
  register,
  errors,
  resp,
  listOptionsresp,
  hideButtons,
  noDataMsg,
  prodCatCheck,
  additionalQuestions,
  nonExcisionalShow,
  nonExcisionalDisabledValues,
  deepestLevelCom,
  excisionalDisable,
  instrumentsUsed,
  ftNecroticSubcutaneousTissue,
  necroticTissueView,
  na,
  techniqueUsed,
  stoppedBleeding,
  customErrors,
  surfaceAreaCheck,
  // default values
  instrumentsUsedDefault,
  defaultValNecroticTissue,
  defaultValNecroticSubTissue,
  defaultValNotApplicable,
  getValue,
  // refs
  listViewRef,
  instrumentsUsedRef,
  necroticTissueRef,
  notapplicableRef,
  // options
  debridementperformedbyOptions,
  nonexcisionalapproachOptions,
  surgicaldebridementprocedureOptions,
  depthofdebridementOptions,
  instrumentsusedOptions,
  necroticsubcutaneoustissueOptions,
  necrotictissueOptions,
  notapplicableOptions,
  postdebridementbleedingamountOptions,
  techniqueusedOptions,
  // handlers
  onCancelClick,
  getPrimaryGroup,
  surgicalPerformedBy,
  debrideProcedureChange,
  performedExcisionalChange,
  postBleedingSelect,
  handleListViewMenuChange,
  necroticTissueChange,
  instrumentsUsedChange,
  notapplicableSelect,
  getOptValue,
  isReadOnly
}) => (
  <div className={style.cont_spac}>
    { isReadOnly && <div className="ml-2"><ReadOnlyBanner /></div> }
    {signedLockedAccess(assessmentDetails?.assessmentStage) ? (
      <Form setFormChangesConfirm={setFormChangesConfirm} formChanges={true} onSubmit={handleSubmit(doSubmit)}>
        {/* Was There Surgical Debridement Performed? */}
        <SelectBox
          id="surgicalDebridementPerformed"
          name="surgicalDebridementPerformed"
          label="Was There Sharp/Surgical Debridement Performed?"
          classes={{
            column: `row ${style.botton_spac} mb-0`,
            inputClassName: `${style.custom_basic_select} ${style.select_wrapper}`,
            labelClassName: `col-5 ${style.label_spec}`,
            inputColumn: "col-6 p-0",
          }}
          optionValue={[
            { key: "yes", value: "Yes" },
            { key: "no", value: "No" },
          ]}
          defaultValue={resp?.isDebridementPerformed}
          required={true}
          errors={errors}
          validator={register(surgicalDebridementPerformed)}
          placeholder="Select"
          onChange={getPrimaryGroup}
        />

        {additionalQuestions && (
          <div>
            {/* Performed By */}
            <SelectBox
              id="performed"
              name="DebridementPerformed"
              label="Sharp/Surgical Debridement Performed By:"
              classes={{
                column: `row ${style.botton_spac} mt-3`,
                inputClassName: `${style.basic_select} ${style.select_wrapper}`,
                labelClassName: `col-5 ${style.label_spec}`,
                inputColumn: "col-6 p-0",
              }}
              optionValue={debridementperformedbyOptions}
              defaultValue={resp?.debridementPerformedBy}
              required={true}
              errors={errors}
              validator={register(debridementPerformedBy)}
              placeholder="Select"
              onChange={surgicalPerformedBy}
            />

            {/* Type of Procedure */}
            <SelectBox
              id="excisional"
              name="performedExcisional"
              label="Type of Sharp/Surgical Debridement Procedure:"
              classes={{
                column: `row ${style.botton_spac}`,
                inputClassName: `${style.basic_select} ${style.select_wrapper}`,
                labelClassName: `col-5 ${style.label_spec}`,
                inputColumn: "col-6 p-0",
              }}
              optionValue={surgicaldebridementprocedureOptions}
              defaultValue={resp?.surgicalDebridementProcedure}
              validator={register(typeProcedure)}
              errors={errors}
              placeholder="Select"
              onChange={debrideProcedureChange}
              required={true}
            />

            {/* Non-Excisional Approach */}
            {nonExcisionalShow && (
              <SelectBox
                id="nonExcisionalId"
                name="nonExcisional"
                label="Non-Excisional Approach:"
                classes={{
                  column: `row ${style.botton_spac}`,
                  inputClassName: `${style.custom_basic_select} ${style.select_wrapper}`,
                  labelClassName: `col-5 ${style.label_spec}`,
                  inputColumn: "col-7 p-0",
                }}
                optionValue={nonexcisionalapproachOptions}
                defaultValue={resp?.nonExcisionalApproach}
                required={true}
                errors={errors}
                validator={register(nonExcisionalApproach)}
                placeholder="Select"
                disabled={excisionalDisable}
                disabledValues={nonExcisionalDisabledValues}
              />
            )}

            {/* Deepest Level */}
            {deepestLevelCom && (
              <SelectBox
                id="deepestLevel"
                name="deepestLevel"
                label="Depth of Debridement - Deepest Level:"
                classes={{
                  column: `row ${style.botton_spac}`,
                  inputClassName: `${style.basic_select} ${style.select_wrapper}`,
                  labelClassName: `col-5 ${style.label_spec}`,
                  inputColumn: "col-6 p-0",
                }}
                optionValue={depthofdebridementOptions}
                required={true}
                errors={errors}
                validator={register(DepthofDebridement)}
                placeholder="Select"
                onChange={performedExcisionalChange}
                defaultValue={resp?.depthOfDebridement}
              />
            )}

            {/* Necrotic Subcutaneous Tissue */}
            {deepestLevelCom && ftNecroticSubcutaneousTissue && (
              <MultiSelect
                id="FTNecroticSubcutaneousTissue"
                name="FTNecroticSubcutaneousTissue"
                label="Necrotic Subcutaneous Tissue:"
                classes={{
                  column: ` row ${style.botton_spac}`,
                  inputClassName: style.basic_select,
                  labelClassName: `col-5 col-form-label ${style.label_spec}`,
                  inputColumn: "col-6 p-0",
                }}
                optionValue={necroticsubcutaneoustissueOptions}
                showCheckbox={true}
                displayValue="value"
                validator={(e) => {
                  register({ required: true });
                  listViewRef.current = e;
                }}
                onSelect={handleListViewMenuChange}
                onRemove={handleListViewMenuChange}
                defaultValue={Array.isArray(defaultValNecroticSubTissue) ? defaultValNecroticSubTissue : []}
                labelSubText={MULTISELECT_SUB_LABLE}
              />
            )}

            {/* Necrotic Tissue */}
            {deepestLevelCom && necroticTissueView && (
              <MultiSelect
                id="necroticTissue"
                name="necroticTissue"
                label="Necrotic Tissue:"
                classes={{
                  column: `row ${style.botton_spac}`,
                  inputClassName: style.basic_select,
                  labelClassName: `col-5 col-form-label ${style.label_spec}`,
                  inputColumn: "col-6 p-0",
                }}
                optionValue={necrotictissueOptions}
                showCheckbox={true}
                displayValue="value"
                validator={(e) => {
                  register({ required: true });
                  necroticTissueRef.current = e;
                }}
                onSelect={necroticTissueChange}
                onRemove={necroticTissueChange}
                defaultValue={Array.isArray(defaultValNecroticTissue) ? defaultValNecroticTissue : []}
                labelSubText={MULTISELECT_SUB_LABLE}
              />
            )}

            {/* N/A */}
            {deepestLevelCom && na && (
              <MultiSelect
                id="na"
                name="na"
                label="N/A:"
                classes={{
                  column: ` row ${style.botton_spac}`,
                  inputClassName: style.basic_select,
                  labelClassName: `col-5 col-form-label ${style.label_spec}`,
                  inputColumn: "col-6 p-0",
                }}
                optionValue={notapplicableOptions}
                showCheckbox={true}
                displayValue="value"
                defaultValue={Array.isArray(defaultValNotApplicable) ? defaultValNotApplicable : []}
                labelSubText={MULTISELECT_SUB_LABLE}
                validator={(e) => {
                  register({ required: true });
                  notapplicableRef.current = e;
                }}
                onSelect={notapplicableSelect}
                onRemove={notapplicableSelect}
              />
            )}

            {/* Instruments Used */}
            {deepestLevelCom && instrumentsUsed && (
              <MultiSelect
                id="instrumentsUsed"
                name="instrumentsUsed"
                label="Instruments Used:"
                classes={{
                  column: ` row ${style.botton_spac}`,
                  inputClassName: style.basic_select,
                  labelClassName: `col-5 col-form-label ${style.label_spec}`,
                  inputColumn: "col-6 p-0",
                  labelSubClass: "{'bir_subline'}",
                }}
                optionValue={instrumentsusedOptions}
                required={true}
                showCheckbox={true}
                displayValue="value"
                customErrors={customErrors}
                validator={(e) => {
                  register();
                  instrumentsUsedRef.current = e;
                }}
                onSelect={instrumentsUsedChange}
                onRemove={instrumentsUsedChange}
                defaultValue={Array.isArray(instrumentsUsedDefault) ? instrumentsUsedDefault : []}
                labelSubText={MULTISELECT_SUB_LABLE}
              />
            )}

            {deepestLevelCom && surfaceAreaCheck && (
              <>
                {/* Surface Area — Necrotic Skin */}
                <TextField
                  id="text"
                  name="DebridedOfNecroticSkin"
                  label={<div className={style.inline_block}>Surface Area Debrided of Necrotic Skin (cm&#178;):</div>}
                  classes={{
                    column: `row col-form-label pt-0 ${style.botton_spac}`,
                    labelClass: `col-5 col-form-label ${style.label_spec}`,
                    inputColumn: "col-6 p-0",
                    inputClassName: `${style.basic_input} ${style.border_color}`,
                  }}
                  type="text"
                  defaultValue={resp?.surfaceAreaOfNecroticSkinTissue}
                  required={true}
                  validator={register(debridedNecroticSkin)}
                  errors={errors}
                />

                {/* Surface Area — Subq Tissue */}
                <TextField
                  id="subqTissue"
                  name="subqTissue"
                  label={<div className={style.inline_block}>Surface Area Debrided of Subq Tissue (cm&#178;):</div>}
                  classes={{
                    column: `row col-form-label pt-0 ${style.botton_spac}`,
                    labelClass: `col-5 col-form-label ${style.label_spec}`,
                    inputColumn: "col-6 p-0",
                    inputClassName: style.basic_input,
                  }}
                  type="text"
                  validator={register()}
                  defaultValue={resp?.surfaceAreaOfNecroticSubqTissue}
                />

                {/* Post Debridement Bleeding Amount */}
                <SelectBox
                  id="bleedingAmount"
                  name="bleedingAmount"
                  label="Post Debridement Bleeding Amount:"
                  classes={{
                    column: `row ${style.botton_spac}`,
                    inputClassName: `${style.custom_basic_select} ${style.select_wrapper}`,
                    labelClassName: `col-5 m-0 ${style.label_spec}`,
                    inputColumn: "col-6 p-0",
                  }}
                  optionValue={postdebridementbleedingamountOptions}
                  validator={register()}
                  placeholder="Select"
                  onChange={postBleedingSelect}
                  defaultValue={resp?.postDebridementBleedingAmount}
                />

                {/* Technique Used */}
                {techniqueUsed && (
                  <SelectBox
                    id="techniqueUsed"
                    name="techniqueUsed"
                    label="Technique Used:"
                    classes={{
                      column: `row ${style.botton_spac}`,
                      inputClassName: `${style.custom_basic_select} ${style.select_wrapper}`,
                      labelClassName: `col-5 m-0 ${style.label_spec}`,
                      inputColumn: "col-6 p-0",
                    }}
                    optionValue={techniqueusedOptions}
                    defaultValue={resp?.techniqueUsed}
                    validator={register()}
                    placeholder="Select"
                  />
                )}

                {/* Stopped Bleeding */}
                {stoppedBleeding && (
                  <div className={`d-flex ${style.botton_spac}`}>
                    <label className={`col-5 col-form-label pr-3 ${style.label_spec}`}>Stopped Bleeding with Contact Pressure:</label>
                    <div>
                      <RadioButton
                        id="SPWConactPressure"
                        name="SPWConactPressure"
                        classes={{
                          labelClass: `custom-control-label col-form-label ${style.custom_control_label}`,
                          inputClassName: `custom-control-input ${style.custom_control_input} col-6`,
                          inputColumn: "custom-control custom-radio custom-control-inline",
                        }}
                        validator={register()}
                        radioOption={["Yes"]}
                        defaultValue={resp?.stoppedBleedingContactPressure || ""}
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* Product category */}
        {!noDataMsg
          ? "Your Formulary doesn't have any Debridement, please contact your Medline Sales Rep"
          : prodCatCheck &&
            listOptionsresp &&
            Array.isArray(listOptionsresp.productCategory) &&
            listOptionsresp.productCategory.length > 0 &&
            listOptionsresp.productCategory.map((items, index) => {
              let defaulVal = "";
              Array.isArray(items.options) &&
                items.options.forEach((chckOpt) => {
                  Array.isArray(getValue) &&
                    getValue.forEach((itemDef) => {
                      if (itemDef.value === chckOpt.materialNumber) {
                        defaulVal = itemDef.value;
                      }
                    });
                });
              return (
                <TreatmentDropDownItem
                  key={index}
                  index={index}
                  id={index + 1}
                  name={items.key}
                  label={items.name}
                  classes={{
                    column: `row ${style.botton_spac}`,
                    inputClassName: style.basic_select,
                    inputColumn: "col-6 p-0",
                    labelClassName: "col-5 mb-0",
                  }}
                  listOptions={items.options}
                  defaultValue={defaulVal || ""}
                  getData={getOptValue}
                />
              );
            })}

        {prodCatCheck && !listOptionsresp?.productCategory && (
          <b className="ml-3">Your Formulary doesn't have any Debridement Products, please contact your Medline Sales Rep</b>
        )}

        {hideButtons && (
          <div className="row">
            <div className="mt-4 pt-2 col-sm-12 p-0">
              <div className="offset-5">
                <Button type="submit" classes={{ className: `btn ${style.btn_save}` }} id="updateBtn" value={SAVE_BTN} />
                <Button classes={{ className: `btn ${style.btn_cancel}` }} type="button" id="cancel" value={CANCEL_BTN} onClick={onCancelClick} />
              </div>
            </div>
          </div>
        )}
      </Form>
    ) : (
      "This wound assessment is signed and locked, cannot be updated."
    )}
  </div>
);
